import { LayerTypes } from '@models/layer'
import MENU from '@/constants/menu-constants'
import ax from 'axios'
import Api from '@/api/Api'
import config from '@/config'

const axiosConfig = {
  baseURL: 'https://community-open-weather-map.p.rapidapi.com/weather',
  timeout: 30000
}
let axios = ax.create(axiosConfig)

export const state = {
  mapState: {
    id: 'default',
    layers: [
      {
        name: 'Bing map layer',
        size: 256,
        bounds: [-180, -85.051129, 180, 85.051129],
        type: LayerTypes.RASTER_BASEMAP,
        deleteAble: false,
        source: {
          type: 'raster',
          tiles: [
            'https://ecn.t0.tiles.virtualearth.net/tiles/a{quadkey}.jpeg?g=7505',
            'https://ecn.t1.tiles.virtualearth.net/tiles/a{quadkey}.jpeg?g=7505',
            'https://ecn.t2.tiles.virtualearth.net/tiles/a{quadkey}.jpeg?g=7505',
            'https://ecn.t3.tiles.virtualearth.net/tiles/a{quadkey}.jpeg?g=7505'
          ],
          tileSize: 256,
          maxzoom: 18,
          minzoom: 1,
          bounds: [-180, -85.051129, 180, 85.051129],
          attribution: 'Bing Maps'
        },

        opacity: 1,
        contrast: 0,
        brightnessMax: 1,
        brightnessMin: 0,
        layoutLeft: false,
        layoutRight: false
      },
      {
        name: 'Label layer',
        size: 256,
        bounds: [-180, -85.051129, 180, 85.051129],
        deleteAble: false,
        type: LayerTypes.RASTER_BASEMAP,
        source: {
          type: 'raster',
          tiles: [`${config.tile_server}/styles/label/{z}/{x}/{y}.png`],
          tileSize: 256,
          maxzoom: 23,
          minzoom: 1,
          bounds: [-180, -85.051129, 180, 85.051129]
        },
        opacity: 1,
        contrast: 0,
        brightnessMax: 1,
        brightnessMin: 0,
        layoutLeft: true,
        layoutRight: true
      }
    ]
  },
  overlayItems: [
    {
      id: MENU.AOI,
      web: true,
      mobile: true,
      eventAction: 'AOIClick',
      eventLabel: 'EOAppAOIOptionClick',
      name: 'AOI',
      value: 'aoi',
      icon:
        '<svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="22" height="22" x="0" y="0" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path xmlns="http://www.w3.org/2000/svg" d="m497.027344 209.589844h-9.8125l-69.691406-119.765625h9.640624c8.269532 0 14.972657-6.703125 14.972657-14.96875v-59.882813c0-8.269531-6.703125-14.972656-14.972657-14.972656h-59.882812c-8.265625 0-14.96875 6.703125-14.96875 14.972656v16.253906h-192.625v-16.253906c0-8.269531-6.703125-14.972656-14.96875-14.972656h-59.882812c-8.269532 0-14.972657 6.703125-14.972657 14.972656v59.882813c0 8.265625 6.703125 14.96875 14.972657 14.96875h7.925781l-69.148438 119.765625h-8.640625c-8.269531 0-14.972656 6.703125-14.972656 14.972656v59.882812c0 8.265626 6.703125 14.96875 14.972656 14.96875h8.640625l70.300781 121.761719h-9.078124c-8.269532 0-14.972657 6.703125-14.972657 14.972657v59.882812c0 8.269531 6.703125 14.96875 14.972657 14.96875h59.882812c8.265625 0 14.96875-6.699219 14.96875-14.96875v-18.253906h192.625v18.253906c0 8.269531 6.703125 14.96875 14.96875 14.96875h59.882812c8.269532 0 14.972657-6.699219 14.972657-14.96875v-59.882812c0-8.269532-6.703125-14.972657-14.972657-14.972657h-10.074218l70.296875-121.761719h9.640625c8.269531 0 14.972656-6.703124 14.972656-14.96875v-59.882812c0-8.269531-6.703125-14.972656-14.972656-14.972656zm-14.96875 29.941406v29.941406h-29.941406v-29.941406zm-99.804688-209.589844h29.941406v29.941406h-29.941406zm-282.449218 0h29.941406v29.941406h-29.941406zm-69.863282 239.53125v-29.941406h29.941406v29.941406zm99.804688 211.585938h-29.941406v-29.941406h29.941406zm282.449218 0h-29.941406v-29.941406h29.941406zm-29.679687-59.882813h-15.234375c-8.265625 0-14.96875 6.703125-14.96875 14.972657v11.6875h-192.625v-11.6875c0-8.269532-6.703125-14.972657-14.96875-14.972657h-16.230469l-70.300781-121.761719h16.667969c8.265625 0 14.96875-6.703124 14.96875-14.96875v-59.882812c0-8.269531-6.703125-14.972656-14.96875-14.972656h-16.667969l69.148438-119.765625h17.382812c8.265625 0 14.96875-6.703125 14.96875-14.96875v-13.6875h192.625v13.6875c0 8.265625 6.703125 14.96875 14.96875 14.96875h15.597656l69.695313 119.765625h-15.429688c-8.265625 0-14.96875 6.703125-14.96875 14.972656v59.882812c0 8.265626 6.703125 14.96875 14.96875 14.96875h15.671875zm0 0" fill="#ffffff" data-original="#000000" style="" class=""/></g></svg>\n'
    },
    {
      id: MENU.IMAGERY,
      web: true,
      mobile: true,
      eventAction: 'ImageryClick',
      eventLabel: 'EOAppImageryOptionClick',
      name: 'Imagery',
      value: 'imagery',
      icon:
        '<svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M20.5833 21.0833H21.0833V20.5833V5.41667V4.91667H20.5833H5.41667H4.91667V5.41667V20.5833V21.0833H5.41667H20.5833ZM8.065 17.9167L10.0333 15.3901L11.7595 17.4686L12.1316 17.9167H8.065ZM15.1168 14.1376L17.9571 17.9167H12.1811L12.539 17.4559L15.1168 14.1376ZM5.41667 3.75H20.5833C21.0254 3.75 21.4493 3.92559 21.7618 4.23816C22.0744 4.55072 22.25 4.97464 22.25 5.41667V20.5833C22.25 21.0254 22.0744 21.4493 21.7618 21.7618C21.4493 22.0744 21.0254 22.25 20.5833 22.25H5.41667C4.97464 22.25 4.55072 22.0744 4.23816 21.7618C3.92559 21.4493 3.75 21.0254 3.75 20.5833V5.41667C3.75 4.97464 3.92559 4.55072 4.23816 4.23816C4.55072 3.92559 4.97464 3.75 5.41667 3.75Z" fill="white" stroke="white"/> </svg>\n'
    },
    {
      id: MENU.VECTORS,
      web: true,
      mobile: true,
      eventAction: 'VectorClick',
      eventLabel: 'EOAppVectorOptionClick',
      name: 'Vectors',
      value: 'vectors',
      icon:
        '<svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
        '<path d="M8.16669 3.75V9.25H7.64835H6.95464L7.17401 9.90811L9.34068 16.4081L9.45464 16.75H9.81502H11.4725H11.6802L11.8267 16.6029L17.6876 10.7204L17.8334 10.5741V10.3675V5.91667H23.3334V11.4167H18.8609H18.6537L18.5073 11.5631L12.6465 17.4239L12.5 17.5704V17.7775V22.25H7.00002V16.75H7.52919H8.2229L8.00353 16.0919L5.83686 9.59189L5.7229 9.25H5.36252H2.66669V3.75H8.16669ZM4.33335 4.91667H3.83335V5.41667V7.58333V8.08333H4.33335H6.50002H7.00002V7.58333V5.41667V4.91667H6.50002H4.33335ZM19.5 7.08333H19V7.58333V9.75V10.25H19.5H21.6667H22.1667V9.75V7.58333V7.08333H21.6667H19.5ZM8.66669 17.9167H8.16669V18.4167V20.5833V21.0833H8.66669H10.8334H11.3334V20.5833V18.4167V17.9167H10.8334H8.66669Z" fill="white" stroke="white"/>\n' +
        '</svg>\n'
    },
    {
      id: MENU.TABLE,
      web: true,
      mobile: true,
      eventAction: 'TablesClick',
      eventLabel: 'EOAppTablesOptionClick',
      name: 'Table',
      value: 'table',
      icon:
        '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px"\n' +
        '     y="0px" viewBox="0 0 122.88 102.52" style="enable-background:new 0 0 122.88 102.52" xml:space="preserve"><style type="text/css">.st0{fill-rule:evenodd;clip-rule:evenodd;}</style>\n' +
        '    <g><path class="st0" fill="#fff" d="M5.42,0h112.04c2.98,0,5.42,2.44,5.42,5.42V97.1c0,2.98-2.44,5.42-5.42,5.42H5.42c-2.98,0-5.42-2.44-5.42-5.42 V5.42C0,2.44,2.44,0,5.42,0L5.42,0z M8.48,23.58H38.1c0.82,0,1.48,0.67,1.48,1.48v9.76c0,0.81-0.67,1.48-1.48,1.48H8.48 c-0.81,0-1.48-0.67-1.48-1.48v-9.76C6.99,24.25,7.66,23.58,8.48,23.58L8.48,23.58z M84.78,82.35h29.63c0.82,0,1.48,0.67,1.48,1.48 v9.76c0,0.81-0.67,1.48-1.48,1.48H84.78c-0.81,0-1.48-0.67-1.48-1.48v-9.76C83.29,83.02,83.96,82.35,84.78,82.35L84.78,82.35z M46.8,82.35h29.28c0.82,0,1.48,0.67,1.48,1.48v9.76c0,0.81-0.67,1.48-1.48,1.48H46.8c-0.81,0-1.48-0.67-1.48-1.48v-9.76 C45.31,83.02,45.98,82.35,46.8,82.35L46.8,82.35z M8.48,82.35H38.1c0.82,0,1.48,0.67,1.48,1.48v9.76c0,0.81-0.67,1.48-1.48,1.48 H8.48c-0.81,0-1.48-0.67-1.48-1.48v-9.76C6.99,83.02,7.66,82.35,8.48,82.35L8.48,82.35z M84.78,62.76h29.63 c0.82,0,1.48,0.67,1.48,1.48V74c0,0.81-0.67,1.48-1.48,1.48H84.78c-0.81,0-1.48-0.67-1.48-1.48v-9.76 C83.29,63.43,83.96,62.76,84.78,62.76L84.78,62.76z M46.8,62.76h29.28c0.82,0,1.48,0.67,1.48,1.48V74c0,0.81-0.67,1.48-1.48,1.48 H46.8c-0.81,0-1.48-0.67-1.48-1.48v-9.76C45.31,63.43,45.98,62.76,46.8,62.76L46.8,62.76z M8.48,62.76H38.1 c0.82,0,1.48,0.67,1.48,1.48V74c0,0.81-0.67,1.48-1.48,1.48H8.48c-0.81,0-1.48-0.67-1.48-1.48v-9.76 C6.99,63.43,7.66,62.76,8.48,62.76L8.48,62.76z M84.78,43.17h29.63c0.82,0,1.48,0.67,1.48,1.48v9.76c0,0.81-0.67,1.48-1.48,1.48 H84.78c-0.81,0-1.48-0.67-1.48-1.48v-9.76C83.29,43.84,83.96,43.17,84.78,43.17L84.78,43.17z M46.8,43.17h29.28 c0.82,0,1.48,0.67,1.48,1.48v9.76c0,0.81-0.67,1.48-1.48,1.48H46.8c-0.81,0-1.48-0.67-1.48-1.48v-9.76 C45.31,43.84,45.98,43.17,46.8,43.17L46.8,43.17z M8.48,43.17H38.1c0.82,0,1.48,0.67,1.48,1.48v9.76c0,0.81-0.67,1.48-1.48,1.48 H8.48c-0.81,0-1.48-0.67-1.48-1.48v-9.76C6.99,43.84,7.66,43.17,8.48,43.17L8.48,43.17z M84.78,23.58h29.63 c0.82,0,1.48,0.67,1.48,1.48v9.76c0,0.81-0.67,1.48-1.48,1.48H84.78c-0.81,0-1.48-0.67-1.48-1.48v-9.76 C83.29,24.25,83.96,23.58,84.78,23.58L84.78,23.58z M46.8,23.58h29.28c0.82,0,1.48,0.67,1.48,1.48v9.76c0,0.81-0.67,1.48-1.48,1.48 H46.8c-0.81,0-1.48-0.67-1.48-1.48v-9.76C45.31,24.25,45.98,23.58,46.8,23.58L46.8,23.58z"/></g></svg>\n'
    },
    {
      id: MENU.MAPS,
      web: true,
      mobile: true,
      eventAction: 'MapsClick',
      eventLabel: 'EOAppMapsOptionClick',
      name: 'Maps',
      value: 'maps',
      icon:
        '<svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M16.7917 13.0013C19.5 13.0013 21.6667 15.168 21.6667 17.8763C21.6667 18.8296 21.3959 19.718 20.9192 20.4763L24.2559 23.8346L22.75 25.3405L19.37 22.0146C18.6225 22.4805 17.7342 22.7513 16.7917 22.7513C14.0834 22.7513 11.9167 20.5846 11.9167 17.8763C11.9167 15.168 14.0834 13.0013 16.7917 13.0013ZM16.7917 15.168C16.0734 15.168 15.3845 15.4533 14.8766 15.9612C14.3687 16.4691 14.0834 17.158 14.0834 17.8763C14.0834 18.5946 14.3687 19.2835 14.8766 19.7914C15.3845 20.2993 16.0734 20.5846 16.7917 20.5846C17.51 20.5846 18.1989 20.2993 18.7068 19.7914C19.2147 19.2835 19.5 18.5946 19.5 17.8763C19.5 17.158 19.2147 16.4691 18.7068 15.9612C18.1989 15.4533 17.51 15.168 16.7917 15.168ZM21.125 2.16797C21.2687 2.16797 21.4065 2.22504 21.508 2.32662C21.6096 2.4282 21.6667 2.56598 21.6667 2.70964V12.7955C21.0384 12.1996 20.3125 11.7121 19.5 11.3763V5.09297L16.25 6.34964V10.8346C15.4917 10.9105 14.755 11.0946 14.0834 11.3763V6.36047L9.75002 4.8438V17.4755V17.8763C9.75002 18.5696 9.84752 19.2413 10.0317 19.8696L8.66669 19.393L2.88169 21.6355L2.70835 21.668C2.56469 21.668 2.42692 21.6109 2.32534 21.5093C2.22376 21.4077 2.16669 21.27 2.16669 21.1263V4.7463C2.16669 4.49714 2.32919 4.30214 2.55669 4.2263L8.66669 2.16797L15.1667 4.44297L20.9517 2.20047L21.125 2.16797ZM4.33335 5.9163V18.7538L7.58335 17.4971V4.82214L4.33335 5.9163Z" fill="white"/> </svg>\n'
    },
    // {
    //   id: MENU.MODELS,
    //   web: true,
    //   mobile: true,
    //   eventAction: 'ModelsClick',
    //   eventLabel: 'EOAppModelsOptionClick',
    //   name: 'Models',
    //   value: 'modelers',
    //   icon:
    //     '<svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M10.1508 4.33464L11.6783 7.04297L10.1508 9.7513H7.1825L5.66583 7.04297L7.1825 4.33464H10.1508ZM11.1042 2.16797H6.22917C6.02333 2.16797 5.83917 2.28714 5.7525 2.44964L3.3475 6.73964L3.25 7.04297L3.3475 7.3463L5.7525 11.6363C5.83917 11.7988 6.02333 11.918 6.22917 11.918H11.1042C11.31 11.918 11.4942 11.7988 11.5808 11.6363L13.9858 7.3463L14.0833 7.04297L13.9858 6.73964L11.5808 2.44964C11.4942 2.28714 11.31 2.16797 11.1042 2.16797ZM20.1717 10.293L21.6667 13.0013L20.1717 15.7096H17.2033L15.7083 13.0013L17.2033 10.293H20.1717ZM21.125 8.1263H16.25C16.0442 8.1263 15.86 8.24547 15.7733 8.40797L13.3683 12.698L13.2708 13.0013L13.3683 13.3046L15.7733 17.5946C15.86 17.7571 16.0442 17.8763 16.25 17.8763H21.125C21.3308 17.8763 21.515 17.7571 21.6017 17.5946L24.0067 13.3046L24.1042 13.0013L24.0067 12.698L21.6017 8.40797C21.515 8.24547 21.3308 8.1263 21.125 8.1263ZM10.1508 16.2513L11.6783 18.9596L10.1508 21.668H7.1825L5.66583 18.9596L7.1825 16.2513H10.1508ZM11.1042 14.0846H6.22917C6.02333 14.0846 5.83917 14.2038 5.7525 14.3663L3.3475 18.6563L3.25 18.9596L3.3475 19.263L5.7525 23.553C5.83917 23.7155 6.02333 23.8346 6.22917 23.8346H11.1042C11.31 23.8346 11.4942 23.7155 11.5808 23.553L13.9858 19.263L14.0833 18.9596L13.9858 18.6563L11.5808 14.3663C11.4942 14.2038 11.31 14.0846 11.1042 14.0846Z" fill="white"/> </svg>\n'
    // },
    // {
    //   id: MENU.DATASETS,
    //   web: true,
    //   mobile: true,
    //   eventAction: 'DatasetsClick',
    //   eventLabel: 'EOAppDatasetsOptionClick',
    //   name: 'Datasets',
    //   value: 'datasets',
    //   icon:
    //     '<svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M13 3.25C8.21165 3.25 4.33331 5.18917 4.33331 7.58333V18.4167C4.33331 20.8108 8.22248 22.75 13 22.75C17.7775 22.75 21.6666 20.8108 21.6666 18.4167V7.58333C21.6666 5.18917 17.7883 3.25 13 3.25ZM19.5 18.4167C19.5 18.9583 17.1925 20.5833 13 20.5833C8.80748 20.5833 6.49998 18.9583 6.49998 18.4167V16.0008C8.24415 16.8458 10.53 17.3333 13 17.3333C15.47 17.3333 17.7558 16.8458 19.5 16.0008V18.4167ZM19.5 13.4875C18.0916 14.5167 15.6216 15.1667 13 15.1667C10.3783 15.1667 7.90831 14.5167 6.49998 13.4875V10.4433C8.09248 11.3425 10.4108 11.9167 13 11.9167C15.5891 11.9167 17.9075 11.3425 19.5 10.4433V13.4875ZM13 9.75C8.80748 9.75 6.49998 8.125 6.49998 7.58333C6.49998 7.04167 8.80748 5.41667 13 5.41667C17.1925 5.41667 19.5 7.04167 19.5 7.58333C19.5 8.125 17.1925 9.75 13 9.75Z" fill="white"/> </svg>\n'
    // },
    // {
    //   id: MENU.RESULTS,
    //   web: true,
    //   mobile: true,
    //   eventAction: 'ResultsClick',
    //   eventLabel: 'EOAppResultsOptionClick',
    //   name: 'Results',
    //   value: 'results',
    //   icon: '<svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M23.8333 4.33464H10.8333C9.64165 4.33464 8.66665 5.2988 8.66665 6.5013V10.8346L6.49998 13.0013L8.66665 15.168V19.5013C8.66665 20.7038 9.64165 21.668 10.8333 21.668H23.8333C25.0358 21.668 26 20.7038 26 19.5013V6.5013C26 5.2988 25.0358 4.33464 23.8333 4.33464ZM23.8333 19.5013H10.8333V6.5013H23.8333V19.5013ZM4.33331 8.66797H2.16665V2.16797H4.33331V8.66797ZM2.16665 17.3346H4.33331V23.8346H2.16665V17.3346ZM5.41665 13.0013C5.41665 14.2038 4.45248 15.168 3.24998 15.168C2.05831 15.168 1.08331 14.2038 1.08331 13.0013C1.08331 11.8096 2.05831 10.8346 3.24998 10.8346C4.45248 10.8346 5.41665 11.8096 5.41665 13.0013ZM16.25 16.338L13.2708 13.088L14.5275 11.8313L16.25 13.543L20.1391 9.66464L21.3958 11.1921L16.25 16.338Z" fill="white"/> </svg>\n'
    // },
    {
      id: MENU.TASKS,
      web: true,
      mobile: true,
      eventAction: 'TasksClick',
      eventLabel: 'EOAppTasksOptionClick',
      name: 'Tasks',
      value: 'tasks',
      icon:
        '<svg width="26" height="27" viewBox="0 0 26 27" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M5.41665 17.4375L8.12498 22.5H2.70831L5.41665 17.4375ZM9.74998 21.375H22.75V19.125H9.74998V21.375ZM5.41665 10.6875L8.12498 15.75H2.70831L5.41665 10.6875ZM9.74998 14.625H22.75V12.375H9.74998V14.625ZM5.41665 3.9375L8.12498 9H2.70831L5.41665 3.9375ZM9.74998 7.875H22.75V5.625H9.74998V7.875Z" fill="white"/> </svg>\n'
    },
    {
      id: MENU.CATALOG,
      web: true,
      mobile: true,
      eventAction: 'HelperClick',
      eventLabel: 'EOAppHelperOptionClick',
      name: 'Explorer',
      value: 'explorer',
      icon:
        '<svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 2048 2048"><path fill="currentColor" d="M1664 896q79 0 149 30t122 82t83 123t30 149q0 80-30 149t-82 122t-123 83t-149 30q-60 0-117-18t-105-53l-437 436q-19 19-45 19t-45-19t-19-45t19-45l436-437q-35-48-53-105t-18-117q0-79 30-149t82-122t122-83t150-30m0 640q53 0 99-20t82-55t55-81t20-100q0-53-20-99t-55-82t-81-55t-100-20q-53 0-99 20t-82 55t-55 81t-20 100q0 53 20 99t55 82t81 55t100 20m-1280 64q0 15 8 27t19 23q29 29 73 51t95 37t100 26t89 16v128h-8q-6 0-8-1q-39-5-90-15t-107-27t-108-40t-95-56t-68-74t-26-95V448q0-48 22-86t58-70t83-54t96-41t95-29t84-18q66-11 132-16t132-6q67 0 133 5t132 18q36 6 83 17t95 29t96 40t83 55t59 69t23 87v320h-128V637q-58 37-130 62t-148 40t-153 22t-145 7t-144-6t-153-22t-149-41t-130-62zM960 256q-57 0-130 6t-148 20t-143 40t-115 63q-14 11-27 27t-13 36q0 19 13 35t27 28q46 38 114 63t143 39t148 21t131 6q57 0 130-6t148-20t143-40t114-63q14-11 27-27t14-36q0-19-13-35t-28-28q-46-38-114-63t-142-39t-148-21t-131-6"/></svg>'
    }
    // {
    //   id: MENU.HELP,
    //   web: true,
    //   mobile: true,
    //   eventAction: 'HelperClick',
    //   eventLabel: 'EOAppHelperOptionClick',
    //   name: 'Help',
    //   value: 'helper',
    //   icon:
    //     '<svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M4.33335 2.16797C3.75872 2.16797 3.20762 2.39624 2.80129 2.80257C2.39496 3.2089 2.16669 3.76 2.16669 4.33464V17.3346C2.16669 17.9093 2.39496 18.4604 2.80129 18.8667C3.20762 19.273 3.75872 19.5013 4.33335 19.5013H8.66669V22.7513C8.66669 23.0386 8.78082 23.3142 8.98399 23.5173C9.18715 23.7205 9.4627 23.8346 9.75002 23.8346H10.2917C10.5625 23.8346 10.8334 23.7263 11.05 23.5205L15.0584 19.5013H21.6667C22.2413 19.5013 22.7924 19.273 23.1988 18.8667C23.6051 18.4604 23.8334 17.9093 23.8334 17.3346V4.33464C23.8334 3.13214 22.8584 2.16797 21.6667 2.16797H4.33335ZM4.33335 4.33464H21.6667V17.3346H14.17L10.8334 20.6713V17.3346H4.33335V4.33464ZM13.2059 5.95964C12.2417 5.95964 11.4725 6.15464 10.8875 6.54464C10.2917 6.93464 9.98835 7.58464 10.0425 8.33214C0.22752 8.33214 7.11752 8.33214 12.1767 8.33214C12.1767 8.0288 12.285 7.8013 12.4584 7.64964C12.675 7.49797 12.9134 7.42214 13.2059 7.42214C13.5417 7.42214 13.8342 7.5088 14.0292 7.7038C14.2242 7.88797 14.3217 8.1263 14.3217 8.4513C14.3217 8.75464 14.235 9.02547 14.0834 9.25297C13.8992 9.4913 13.6717 9.6863 13.39 9.83797C12.8267 10.1846 12.4584 10.488 12.2309 10.748C12.025 11.008 11.9167 11.3763 11.9167 11.918H14.0834C14.0834 11.6146 14.1375 11.3763 14.235 11.1813C14.3325 10.9971 14.5167 10.8346 14.7984 10.6721C15.2967 10.4446 15.7084 10.1413 16.0225 9.7513C16.3367 9.35047 16.4992 8.92797 16.4992 8.4513C16.4992 7.69297 16.2067 7.0863 15.6217 6.6313C15.0367 6.18714 14.2242 5.95964 13.2059 5.95964ZM11.9167 13.0013V15.168H14.0834V13.0013H11.9167Z" fill="white"/> </svg>\n'
    // }
  ],
  compare: false,
  AOI: undefined
}

export const getters = {
  layers(state) {
    return state.mapState.layers
  },
  RasterBaseMap(state) {
    return state.mapState.layers
  },
  overlayItems(state) {
    return state.overlayItems
  },
  compareMap(state) {
    return state.compare
  },
  currentAOI(state) {
    return state.AOI
  }
}

export const mutations = {
  SET_LAYERS(state, val) {
    if (val && val.length > 0) {
      state.mapState.layers = val
    }
    if (val && val.id) {
      saveState(val.id, JSON.stringify(val))
    }
  },
  SET_COMPARE(sate, val) {
    sate.compare = val
  },
  SET_AOI(state, val) {
    if (val && val.aois.features.length > 0) {
      state.AOI = val
      saveAOI(val.id, JSON.stringify(val))
    } else if (val && val.aois.features.length <= 0) {
      state.AOI = undefined
      resetStorageAOI(val.id)
    }
  },
  RESET_AOI(state) {
    state.AOI = undefined
  }
}
export const actions = {
  setLayers({ commit, state, rootState }, val) {
    commit('SET_LAYERS', val)
  },
  setCompare({ commit, state, rootState }, val) {
    commit('SET_COMPARE', val)
  },
  getWorkspaceMapLayers({ commit, dispatch, getters }, workspaceId) {
    let layers = JSON.parse(getSavedState(workspaceId))
    let aoi = JSON.parse(getSavedState(workspaceId + 'CurrentAoi'))
    commit('SET_LAYERS', layers)
    commit('SET_AOI', aoi)
    return layers
  },
  async saveWorkspaceMapLayers({ commit, dispatch, getters }, data) {
    const submitType = data.submitType
    const projectInfo = { ...data.projectInfo }
    const defaultCallback = data.defaultCallback
    const sucessCallback = data.sucessCallback
    const errorCallback = data.errorCallback
    delete data.projectInfo
    delete data.submitType
    projectInfo.layers = JSON.stringify({ ...data })
    if (submitType === 'create') {
      try {
        const res = await Api.createProject(data.id, projectInfo)
        commit('SET_LAYERS', res.data.layers)
        sucessCallback()
        return res
      } catch (e) {
        errorCallback(e)
        return e
      } finally {
        defaultCallback()
      }
    } else if (submitType === 'edit') {
      try {
        const res = await Api.updateProject(data.id, projectInfo.id, projectInfo)
        commit('SET_LAYERS', res.data.layers)
        sucessCallback()
        return res
      } catch (e) {
        errorCallback(e)
        return e
      } finally {
        defaultCallback()
      }
    } else {
      console.log('make sure submit type is either edit or create')
    }
  },
  resetStorage({ commit, dispatch, getters }, id) {
    commit('RESET_AOI')
    window.localStorage.removeItem(id)
  },
  saveStorageAOI({ commit, dispatch, getters }, data) {
    commit('SET_AOI', data)
  },
  getWeather({ commit, state }, latlng) {
    let options = {}
    options.params = { lat: latlng.lat, lon: latlng.lng }
    options.url = `https://community-open-weather-map.p.rapidapi.com/weather`
    options.method = 'GET'
    options.headers = {
      'x-rapidapi-host': 'community-open-weather-map.p.rapidapi.com',
      'x-rapidapi-key': 'dec76d107cmsh8d1ab0a028ac3a7p1aef22jsn74cc703368d4'
    }
    return axios(options)
      .then(res => {
        return res
      })
      .catch(er => {
        console.log(er)
      })
  }
}

function resetStorageAOI(id) {
  window.localStorage.removeItem(id)
}

function getSavedState(key) {
  return window.localStorage.getItem(key)
}

function saveState(key, state) {
  // window.localStorage.removeItem(key);
  // window.localStorage.setItem(key, state);
}
function saveAOI(key, state) {
  window.localStorage.removeItem(key)
  window.localStorage.setItem(key, state)
}



// WEBPACK FOOTER //
// ./src/state/modules/map.js